import { coerceToType } from '@gonfalon/types/coerceToType';
import { couldBeBoolean } from '@gonfalon/types/couldBeBoolean';
import { couldBeNumber } from '@gonfalon/types/couldBeNumber';
import { isString } from 'lodash';

import type { ClauseValue } from '../types';

export const getClauseCoercedValue = (value: ClauseValue, expectedType?: 'string' | 'number') => {
  if (expectedType) {
    return coerceToType(value, expectedType);
  }

  if (couldBeNumber(value)) {
    if (isString(value) && value.length > 16) {
      //https://www.ecma-international.org/ecma-262/5.1/#sec-8.5. store large numbers as strings to avoid rounding errors
      return value;
    } else if (coerceToType(value, 'number').toString() !== value) {
      // don't prevent the ability to enter strings with leading or trailing zeroes
      return value;
    }
    return coerceToType(value, 'number');
  } else if (couldBeBoolean(value)) {
    return coerceToType(value, 'boolean');
  } else {
    return value;
  }
};
